export default "__VITE_ASSET__505c818f__"